import type { PrintAgentHealth } from '../infra/agentClient';

/**
 * Estado semántico del agente para la UI de Dispositivos.
 * 'unreachable' agrupa apagado/no-instalado — el browser no puede
 * distinguirlos; la card ofrece ambas acciones (Abrir + Descargar).
 */
export type AgentStatus = 'probing' | 'running' | 'unreachable';

export function resolveAgentStatus(args: {
  probing: boolean;
  health: PrintAgentHealth | null;
}): AgentStatus {
  if (args.probing) return 'probing';
  return args.health?.ok ? 'running' : 'unreachable';
}

/** Hace cuánto salió el último job, en copy corto para el badge/meta. */
export function formatLastPrintAgo(lastPrintAt: number | null | undefined, now = Date.now()): string | null {
  if (!lastPrintAt) return null;
  const diffMin = Math.max(0, Math.round((now - lastPrintAt) / 60000));
  if (diffMin < 1) return 'recién';
  if (diffMin < 60) return `hace ${diffMin} min`;
  const hours = Math.round(diffMin / 60);
  if (hours < 24) return `hace ${hours} h`;
  const days = Math.round(hours / 24);
  return `hace ${days} d`;
}
